export enum LINK_TYPES {
  STANDARD = 1,
  GO_TO_MAPS = 2,
}
